import apis from '@api/api';

type TemplateRecord = Record<string, any>;

const coerceObjectId = (value: any) => {
  if (!value) return undefined;
  if (typeof value === 'string') return value;
  if (typeof value?.toString === 'function') return value.toString();
  return value;
};

export const normalizeDocumentTemplates = (templates: TemplateRecord[] = []) => {
  return templates.map((template) => {
    const title = template?.title || template?.templateTitle || template?.name || 'Untitled Document';
    return {
      ...template,
      title,
      dataTitle: template?.dataTitle || title,
      description: template?.description || template?.templateDescription || '',
      dataType: 'document',
      owner: template?.createdBy,
      createdBy: coerceObjectId(template?.createdBy?._id ?? template?.createdBy),
      count: template?.count ?? 0,
      viewCount: template?.viewCount ?? 0,
      interactionCount: template?.interactionCount ?? 0,
      updatedAt: template?.updatedAt || template?.createdAt || new Date().toISOString(),
    };
  });
};

export const normalizeInvoiceTemplates = (templates: TemplateRecord[] = []) => {
  return templates.map((template) => {
    const title = template?.title || template?.invoice_template_name || template?.name || 'Untitled Invoice';
    return {
      ...template,
      title,
      dataTitle: template?.dataTitle || title,
      description: template?.description || template?.template_description || '',
      dataType: 'invoice',
      owner: template?.createdBy,
      createdBy: coerceObjectId(template?.createdBy?._id ?? template?.createdBy),
      updatedAt: template?.updatedAt || template?.createdAt || new Date().toISOString(),
    };
  });
};

export const fetchTemplatesByFilter = async (dataFilter?: string) => {
  if (dataFilter === 'documents') {
    const data = await apis.getDocumentTemplates();
    return normalizeDocumentTemplates(Array.isArray(data) ? data : []);
  }

  if (dataFilter === 'invoices') {
    const data = await apis.getInvoiceTemplates();
    return normalizeInvoiceTemplates(Array.isArray(data) ? data : []);
  }

  return null;
};
